@import 'close';

.alert {
	margin-bottom: 0;
	border-radius: 0;
	padding: 25px 0;
	position: relative;
	z-index: 10;


	&-dismissible {

		.container {
			position: relative;
			padding-right: 3rem;
		}

		.btn-close {
			padding: 0;
			top: calc((-1 * #{$spacer}) + #{$gutter-sm});
			background-size: 13px 13px;
			background: none;
			opacity: 1;

			svg {
				@include svg-format(13px, 13px, #FFFFFF);
			}
		}
	}

	a {
		color: #FFFFFF;
		text-decoration: none;

		&:hover, &:focus {
			color: #FFFFFF;
			text-decoration: underline;
			
		}
	}

	.btn-close {
		position: absolute;
		top: 0;
		right: 0;
	}

	&.has-icon {
		
		> .container {
			padding-left: $spacer * 4;

			p{
				margin: 0 30px;
			}
	
			kdx-arrow-link{
				margin: 0 30px;
			}
		}

		.alert-icon {
			position: absolute;
			left: 0;
			height: 50px;
			width: 50px;

			svg {
				@include svg-format(100%, 100%, #FFFFFF);
			}
		}
		
	}

	// Client Scope
	.container {

		.desc {
			color: #FFFFFF;
			@include line-height(24); 
			padding-bottom: 8px;

			> * {
				color: #FFFFFF;
				@include line-height(24); 
				padding-bottom: 8px;
			}

		} 
		
		.btn.btn-secondary {
			color: #FFFFFF;
			padding: 0;

			svg { fill: #FFFFFF; }
		}

		.cookie-links {
			.btn-close { fill: #FFFFFF; }
		}
	}
	&-general {
		background-color: $primary;
	}

	&-urgent {
		background-color: #CC0C17;
	}

	@include media-breakpoint-down(md) {

		.container {
			.desc {
				padding-top: 13px;

				p {
					@include text-size(14);
					@include line-height(22);
				}
			}
		}
	}

	@include media-breakpoint-down(md) {
		&-dismissible {
			.btn-close {
				padding: 0;
				top: -12px;
				right: 35px;
				background-size: 13px 13px;
			}
		}

		&.kdx-alert {
			[class^="arrow-link"]:last-child,
			[class^="arrow-link"] {
				margin: $gutter-sm 0 0;
			}

			&.has-icon {
				> .container {
					padding: 0;
				}

				.alert-icon {
					margin: 6px auto 8px auto;
					position: relative;
					left: 0;
					height: 25px;
					width: 25px;
				}
			}

			p {
				font-size: 12px;
			}

			> .container {
				display: flex;
				flex-direction: column;
				padding: 0;
			}
		}
		&.has-icon {
			> .container {
				padding: 0 30px;
				.alert-icon {
					position: relative;
					width: 100%;
					display: flex;
					justify-content: center;
					
	
					svg {
						@include svg-format(43px, 38px, #FFFFFF);
					}
				}
			}
		}
	}
}